<template>
  <div class="d-none d-print-block mb-2">
    <div class="d-flex flex-row justify-space-between">
      <div style="max-width: 70%;">
        {{ $dayjs.nicerDate(event.startDate, event.endDate) }}
        <AppShowEventReferenceCode :event="event"
          ><template #prepend> | </template></AppShowEventReferenceCode
        >
        |
        <AppShowCountry :show-flag="false" :country="event.country">
          <template #append
            >{{ event.region ? ", " + event.region.name : ""
            }}{{ event.place ? ", " + event.place : "" }}
          </template>
        </AppShowCountry>

        <h2>
          {{ event.name }}
        </h2>
        {{ event.organiser.name }}
      </div>
      <div>
        {{ $dayjs.date($dayjs(), "fullTime") }}
      </div>
    </div>
  </div>
</template>
<script>
/* Component is made to replace event cards for printing/generating pdf */
import { defineComponent } from "vue";
import gql from "fraql";
import AppShowCountry from "@AppShows/AppShowCountry.vue";
import AppShowEventReferenceCode from "@AppShows/event/AppShowEventReferenceCode.vue";

export default defineComponent({
  name: "AppShowEventPrintBasic",
  components: { AppShowCountry, AppShowEventReferenceCode },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  fragments: {
    event: gql`
      fragment _ on Event {
        name
        ${AppShowEventReferenceCode.fragments.eventFields}
        startDate
        endDate
        place
        regionId
        region @client {
          id
          name
        }
        countryId
        country @client {
          id
          name
          ioc
          alpha2
        }
        organiser {
          id
          name
        }
      }
    `
  }
});
</script>
